const images = {
  logo_operator: require('./images/LOGO_OPERATOR.png'),
  scan_help_ticket_illustration: require('./images/ticket_illustration.png'),
}

export default images
